import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { connectionState, type ConnState } from '../state/connection-state.js';

/**
 * Ekranın ALTINDA sabit bağlantı durumu bandı (üstteki header/marka kapanmasın diye altta).
 * online -> gizli; reconnecting -> sarı; offline -> kırmızı + "X sn önce".
 */
@customElement('fp-connection-banner')
export class FpConnectionBanner extends LitElement {
    @state() private conn: ConnState = connectionState.state;
    @state() private agoSec = 0;

    private timer?: number;
    private onChange = (): void => {
        this.conn = connectionState.state;
        // Durum değişimi anında sayacı hemen tazele (bir sonraki 1sn tick'ini bekleme) —
        // kesilme anında eski "190 sn" değerinin <1sn görünmesini önler.
        this.agoSec = Math.floor((Date.now() - connectionState.lastOnlineMs) / 1000);
    };

    static styles = css`
        :host {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 9999;
        }
        .bar {
            padding: 0.5rem 1rem;
            text-align: center;
            font: 600 1rem/1.2 'Inter', system-ui, sans-serif;
        }
        .bar.reconnecting {
            background: #f59e0b;
            color: #000;
        }
        .bar.offline {
            background: #dc2626;
            color: #fff;
        }
        .dot {
            display: inline-block;
            width: 0.7em;
            height: 0.7em;
            border-radius: 50%;
            margin-right: 0.5em;
            vertical-align: -0.05em;
            background: currentColor;
        }
        .hidden {
            display: none;
        }
    `;

    connectedCallback(): void {
        super.connectedCallback();
        connectionState.addEventListener('change', this.onChange);
        this.timer = window.setInterval(() => {
            this.agoSec = Math.floor((Date.now() - connectionState.lastOnlineMs) / 1000);
        }, 1000);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        connectionState.removeEventListener('change', this.onChange);
        if (this.timer !== undefined) clearInterval(this.timer);
    }

    render() {
        if (this.conn === 'online') {
            return html`<div class="hidden"></div>`;
        }
        const label = this.conn === 'reconnecting'
            ? 'Yeniden bağlanıyor...'
            : 'Bağlantı yok';
        return html`
            <div class="bar ${this.conn}">
                <span class="dot"></span>${label} — son güncelleme ${this.agoSec} sn önce
            </div>
        `;
    }
}
